import { useContext } from "react";
import { store } from "../store.js";
import useGetDataFromPathId from "./useGetDataFromPathId.js";

const useSetDataVariableInText = () => {
  const globalState = useContext(store);
  const getDataFromPathId = useGetDataFromPathId();

  const setDataVariableInText = (inputText, checkedDetail) => {
    checkedDetail.forEach(detail => 
      inputText = inputText.replace(detail.value, 
        getDataFromPathId(globalState.state.formData, detail.checkeds))
      )
    return inputText;
  };

  return setDataVariableInText;
};

export default useSetDataVariableInText;
